import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import './ColorSelect.css';

const ColorSelect = ({ value, onChange, error }) => {
  const { t } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const colors = [
    { value: 'ivory', hex: '#FFFFF0' },
    { value: 'white', hex: '#FFFFFF' },
    { value: 'champagne', hex: '#F7E7CE' },
    { value: 'blush', hex: '#F5C6CB' },
    { value: 'black', hex: '#000000' },
    { value: 'blue', hex: '#0000FF' },
    { value: 'gold', hex: '#FFD700' },
    { value: 'pink', hex: '#FFC0CB' },
    { value: 'purple', hex: '#800080' },
    { value: 'red', hex: '#FF0000' },
    { value: 'green', hex: '#008000' },
    { value: 'yellow', hex: '#FFFF00' },
    { value: 'gray', hex: '#808080' },
    { value: 'orange', hex: '#FFA500' },
    { value: 'mint', hex: '#98FF98' },
    { value: 'mocha', hex: '#967969' }
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (colorValue) => {
    onChange({ target: { name: 'colour', value: colorValue } });
    setIsOpen(false);
  };

  const selectedColor = colors.find(c => c.value === value);

  return (
    <div className={`color-select ${error ? 'error' : ''}`} ref={dropdownRef}>
      <div 
        className="color-select-trigger" 
        onClick={() => setIsOpen(!isOpen)}
      >
        {value ? (
          <div className="colour-display">
            <div 
              className="colour-circle"
              style={{ backgroundColor: selectedColor?.hex }}
            ></div>
            <span className="colour-name">
              {t(`dresses.colors.${value}`)}
            </span>
          </div>
        ) : (
          <span className="placeholder">{t('dresses.selectColor')}</span>
        )}
        <span className="dropdown-arrow">▼</span>
      </div>

      {isOpen && (
        <div className="color-select-dropdown">
          {colors.map((color) => (
            <div
              key={color.value}
              className={`color-option ${value === color.value ? 'selected' : ''}`}
              onClick={() => handleSelect(color.value)}
            >
              <div 
                className="colour-circle"
                style={{ backgroundColor: color.hex }}
              ></div>
              <span className="colour-name">
                {t(`dresses.colors.${color.value}`)}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ColorSelect;

